import { render } from "./RequestUserPolicyWidget.vue?vue&type=template&id=7c21bbb3&ts=true"
import script from "./RequestUserPolicyWidget.ts?vue&type=script&lang=ts&external"
export * from "./RequestUserPolicyWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__